module.exports = {"150722100":"尼尔基镇","150722102":"宝山镇","150722103":"哈达阳镇","150722104":"阿尔拉镇","150722105":"汉古尔河镇","150722106":"西瓦尔图镇","150722108":"腾克镇","150722109":"奎勒河镇","150722110":"塔温敖宝镇","150722111":"登特科镇","150722112":"红彦镇","150722201":"库如奇乡","150722202":"额尔和乡","150722203":"杜拉尔鄂温克民族乡","150722205":"巴彦鄂温克民族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150722.json
// module id = 536
// module chunks = 0